/*
 * Created on Wed Nov 01 2023 4:27:51 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import React from "react";
import { getIcon } from "../utils/iconResolver";
import data from "../data/krumagoData.json";

const ParentPhilosophy = () => {
  const { philosophy } = data;

  return (
    <section className="relative py-16 sm:py-20 lg:py-28 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50/30 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-64 h-64 sm:w-96 sm:h-96 bg-blue-100/40 rounded-full blur-3xl opacity-30 animate-pulse" />
        <div className="absolute bottom-0 right-0 w-64 h-64 sm:w-96 sm:h-96 bg-purple-100/40 rounded-full blur-3xl opacity-30 animate-pulse delay-1000" />
      </div>

      <div className="relative max-w-7xl mx-auto">

        {/* Stats Row */}
        {/* <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-16 sm:mb-20 lg:mb-24">
          {philosophy.stats.map((stat, index) => (
            <div
              key={index}
              className="text-center group hover:scale-105 transition-transform duration-500"
            >
              <div
                className={`inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br ${stat.gradient} rounded-3xl shadow-2xl mb-4 sm:mb-6 transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-500`}
              >
                <div className="text-white">
                  {getIcon(stat.icon, { className: "w-7 h-7 sm:w-8 sm:h-8" })}
                </div>
              </div>
              <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 mb-1 sm:mb-2">
                {stat.value}
              </div>
              <div className="text-slate-600 text-base sm:text-lg font-semibold">{stat.label}</div>
            </div>
          ))}
        </div> */}

        {/* Philosophy Block */}
        <div className="max-w-4xl mx-auto text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-6 sm:mb-8 tracking-tight leading-tight">
            {philosophy.headline.main}{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              {philosophy.headline.accent}
            </span>
          </h2>

          {philosophy.body.map((paragraph, index) => (
            <p
              key={index}
              className={`text-lg sm:text-xl lg:text-2xl text-slate-600 leading-relaxed font-light ${
                index < philosophy.body.length - 1 ? "mb-4 sm:mb-6" : ""
              }`}
            >
              {paragraph}
            </p>
          ))}
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
          {philosophy.values.map((value, index) => (
            <div
              key={index}
              className="group bg-white/80 backdrop-blur-sm border border-slate-200/60 rounded-2xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 text-center"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-white border border-slate-200 rounded-2xl mb-4 sm:mb-6 shadow-sm group-hover:shadow-md group-hover:scale-110 transition-all duration-500">
                {getIcon(value.icon, { className: `w-5 h-5 sm:w-6 sm:h-6 ${value.iconColor}` })}
              </div>
              <h4 className="font-black text-slate-900 mb-2 sm:mb-3 text-base sm:text-lg group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-purple-600 transition-all duration-500">
                {value.title}
              </h4>
              <p className="text-slate-600 text-xs sm:text-sm font-light leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ParentPhilosophy;